module.exports = __webpack_public_path__ + "static/media/shingan_logo_row.ce9dd1da.png";